export default "__VITE_ASSET__CvFD_A32__"